import { render, staticRenderFns } from "./CustomSection06.vue?vue&type=template&id=2ade59dc&"
import script from "./CustomSection06.vue?vue&type=script&lang=js&"
export * from "./CustomSection06.vue?vue&type=script&lang=js&"
import style0 from "./CustomSection06.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomSection06.vue"
export default component.exports